import { useQuery } from "@tanstack/react-query";

import { getFeatureflags } from "../services/featureFlags";

export const useFeatureflags = () => {
  const get = async () => {
    const response = await getFeatureflags();
    return response;
  };

  const { data, isLoading } = useQuery({
    queryFn: get,
    queryKey: ["featureflags"],
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60 * 24, // 24 hours
  });

  const hasFeature = (feature: string) => {
    return data?.find((flag) => flag.feature === feature)?.enabled;
  };

  return {
    data,
    hasFeature,
    isLoading,
  };
};
